<app-patient-info [heading]="Item"></app-patient-info>

<p-table
  *ngIf="problem"
  [responsive]="true"
  [columns]="selectedColumns"
  [value]="problem.data"
  selectionMode="single"
  dataKey="problemId"
  [resetPageOnSort]="true"
  [lazy]="false"
  [rows]="rows"
  [paginator]="showRecords"
  (sortFunction)="customSort($event, 1)"
  [customSort]="true"
         
>
  <ng-template pTemplate="caption">
    <!--<div class="col-12">
        <span class=" p-float-label">
            <input id="lastName" [(ngModel)]="lastName" type="text" pInputText autocomplete="off">
            <label for="lastName">Last Name</label>
        </span>
        </div>-->
    <div class="formgroup-inline col-12 pb-0">
      <div class="field pt-1">
        <p-multiSelect
          [options]="cols"
          [(ngModel)]="selectedColumns"
          optionLabel="header"
          contenteditable="false"
          [showToggleAll]="true"
          selectedItemsLabel="{0} columns selected"
          [style]="{ minWidth: '200px' }"
          placeholder="Choose Columns"
        >
        </p-multiSelect>
      </div>
      <div class="field col-5 pb-0 pt-1 p-input-icon-right">
        <label htmlfor="txtProblemSerach" class="p-sr-only"
          >Enter your search</label
        >
        <!--<i
          class="pi"
          (click)="startListening()"
          title="Search by voice"
          id="voiceIconId"
          style="color: #4285f4; cursor: pointer; transition: color 0.3s ease"
          [ngClass]="{
            'active-icon': isListening,
            'inactive-icon': !isListening,
          }"
          *ngIf="isSearchByVoice"
          >🎤</i
        >-->
        <input
          pinputtext=""
          id="txtProblemSerach"
          type="text"
          placeholder="Enter your search"
          class="text-base text-color p-2 w-12"
          [(ngModel)]="txtSearch"
          style="width: auto; height: 37px"
        />
      </div>
      <div class="pb-0 pt-1 BH">
        &nbsp;
        <button
          pButton
          type="button"
          icon="pi pi-search"
          label="Search"
          (click)="searchProblems()"
          class="p-button-plain"
        ></button>
        &nbsp;<p-button
          label="Clear"
          severity="secondary"
          (click)="clearSearch()"
          icon="pi pi-refresh"
        ></p-button>

        &nbsp;
        <button
          pButton
          type="button"
          icon="pi pi-print"
          label="Print"
          class="p-button-plain"
          (click)="printProblems()"
          title="Print Problems"
          *ngIf="setPrintFlag"
        ></button
        >&nbsp;
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="header" let-columns>
    <tr>
      <th *ngFor="let col of columns" [pSortableColumn]="col.field">
        {{ col.header }}
        <p-sortIcon [field]="col.field"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-rowData
    let-columns="columns"
    let-i="rowIndex"
  >
    <tr [pSelectableRow]="rowData">
      <td *ngFor="let col of columns">
        <ng-container *ngIf="col.field != 'isResolved'; else ptflag">
          <!--<span class="column-title">{{col.header}}</span>-->
          {{ rowData[col.field] }}
        </ng-container>
        <ng-template #ptflag>
          <ng-container
            *ngIf="
              rowData['isResolved'] && col.field == 'isResolved';
              else ptflagNo
            "
          >
            <span class="column-title"></span>Yes
          </ng-container>
        </ng-template>
        <ng-template #ptflagNo>
          <span class="column-title"></span>No</ng-template
        >
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <div class="w-12 bg-white">
      <div class="" style="text-align: center">
        <img
          _ngcontent-ng-c683320295=""
          class="profile-image"
          style="border-radius: 50%; width: 10rem; padding-top: 1rem"
          src="assets/imagesNew/table_error.png"
        />
      </div>
      <hr style="margin-bottom: 0.5rem" />
      <div class=""
           style="text-align: center; font-size: larger; color: #1d428f">
          <i>No records found</i>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="paginatorleft" let-state>
      <span *ngIf="state.totalRecords > pageSize">
          Showing {{ state.page * state.rows + 1 }} to
          {{ state.rows * (state.page + 1) }} of {{ state.totalRecords }} records.
      </span>
  </ng-template>
</p-table>

<!-- Print functionality  for problem List -->
<div
  class="panel table-responsive"
  id="PrintProblem_List"
  style="display: none"
>
  <div
    style="
      display: flex;
      background-color: #ffffff;
      margin-bottom: 1.5%;
      padding: 0.5%;
    "
  >
    <div
      style="
        display: flex;
        justify-content: left;
        align-items: center;
        width: 50%;
      "
    >
      <span>Problems:&nbsp;</span>
    </div>
    <div
      style="
        display: flex;
        justify-content: right;
        align-items: center;
        width: 50%;
      "
    >
      <span
        ><strong>{{ patientFullName }}</strong></span
      >
    </div>
  </div>

  <div
    style="
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0% 0% 0% 0%;
    "
  >
    <table
      style="width: 100%; border-collapse: collapse; border: 1px solid grey"
      id="problem_print_table_tbody"
    >
      <thead
        style="
          background-color: #142066;
          border: 0px solid #808080;
          color: snow;
        "
      >
        <tr>
          <th
            *ngFor="let col of _selectedColumns"
            style="border: 1px solid #808080; text-align: left"
          >
            {{ col.header }}
          </th>
        </tr>
      </thead>
      <tbody id="appointment_print_table_tbody">
        <tr
          *ngFor="let item of problem?.data"
          style="border: 1px solid #808080"
        >
          <td
            *ngFor="let col of _selectedColumns"
            style="
              text-align: left;
              border: 1px solid #808080;
              padding: 0.5% 0% 0.5% 0%;
            "
          >
            {{ item[col.field] }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div *ngIf="problem?.data.length == 0"
       class="alert alert-warning"
       role="alert"
       style="text-align: center">
      <span class="glyphicon glyphicon-exclamation-sign"
            aria-hidden="true"></span>
      <span class="sr-only">Error:</span>
      <i>No records found</i>
  </div>
</div>
